module.exports = __webpack_public_path__ + "static/media/page-not-found-icon.3111a61e.svg";